<ng-container>
  <span *ngIf="state.icon" class="icon"><fa-icon [icon]="['fal', state.icon]"></fa-icon></span>
  {{ state.label }}
</ng-container>
